import type { OrderAttributesFieldValues } from "@jti/commerce-types/types";
import type { ApiMagentoOrderAttributeInput } from "@jti/magento-types";

export const prepareMagentoAdditionalAttributes = (
  attributes: OrderAttributesFieldValues
): ApiMagentoOrderAttributeInput[] => {
  return Object.entries(attributes).reduce<ApiMagentoOrderAttributeInput[]>((acc, [key, value]) => {
    if (value === undefined || value === null) {
      return acc;
    }

    acc.push({
      attribute_code: key,
      value: String(value),
    });
    return acc;
  }, []);
};
